import VehicleOffering from '@carvana/merch-contracts/VehicleOffering';
import { useClientSide } from '@carvana/merch-react-hooks';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import GeoModal from '@/common/helios/Modals/GeoModal';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useModalContext } from '~/context/new-cars/ModalContext';

export default function GeolocationModal() {
  const { isGeolocationModalOpen, setGeolocationModalOpen } = useModalContext();
  const router = useRouter();
  const isClientSide = useClientSide();
  const trackEvent = useTrackEvent();

  const onSuccessfulZipChange = useCallback(() => {
    router.refresh();
  }, [router]);

  if (!isClientSide) return null;

  return (
    <GeoModal
      isGeolocationModalOpen={isGeolocationModalOpen}
      offeringType={VehicleOffering.New}
      onSuccessfulZipChange={onSuccessfulZipChange}
      setGeolocationModalOpen={setGeolocationModalOpen}
      trackEvent={trackEvent}
    />
  );
}
